import {Modal, ModalBody, ModalContent, ModalHeader} from '@heroui/react';
import Languages from 'components/MoreMenuElements/Languages';

export default function SelectLanguageModal({isOpen, onOpenChange, saveToLocalStorage}) {
	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={() => onOpenChange()}
			size={saveToLocalStorage ? 'full' : '2xl'}
			isDismissable={saveToLocalStorage ? false : true}
			radius='none'
			hideCloseButton={saveToLocalStorage ? true : false}
			className='bg-background'
			classNames={{
				base: saveToLocalStorage ? 'm-0 flex flex-col max-w-[820px] md:max-w-[500px] ' : 'm-0 flex flex-col max-w-[820px] md:max-w-[500px] max-h-[90vh]',
				wrapper: 'sm:items-end',
				closeButton: 'z-50 bg-primary text-primary-foreground',
			}}>
			<ModalContent>
				{(onClose) => (
					<>
						<ModalHeader className='flex flex-col gap-1'></ModalHeader>
						<ModalBody className={'select-none overflow-hidden'}>
							<Languages className='moreMenu-accordion -quick' close={() => onOpenChange()} saveToLocalStorage={saveToLocalStorage} />
						</ModalBody>
					</>
				)}
			</ModalContent>
		</Modal>
	);
}
